import { Color } from "@bonliva-crm/ui";
import { UnderScoreColor } from "./utils";

type Props = {
  color: UnderScoreColor;
};

export function Underscore(props: Props) {
  switch (props.color) {
    case "blue":
      return (
        <div
          style={{
            ...style,
            backgroundColor: Color.Information
          }}
        />
      );
    case "primary":
      return (
        <div
          style={{
            ...style,
            backgroundColor: Color.PrimaryMain
          }}
        />
      );
    case "dashed-green":
      return (
        <div
          style={{
            ...style,
            backgroundColor: Color.White,
            backgroundImage: `repeating-linear-gradient(
            -45deg,
            ${Color.CheckGreen},
            rgba(76, 217, 100, 0.35) 2px,
            rgba(76, 217, 100, 0.35) 2px,
            ${Color.CheckGreen} 4px
          )`
          }}
        />
      );
  }
}

const style = {
  width: "75%",
  height: "3px",
  borderRadius: "2px",
  marginTop: "2px",
  bottom: "0",
  left: "0"
};
